import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { SocketService } from './socket.service';

@Injectable({
    providedIn: 'root'
})
export class NotificacionesService {

    constructor(
        private wsService: SocketService,
        private http: HttpClient
    ) { }

    socketNotify() {
        return this.wsService.listen('alerta-notificacion');
    }

    getAllNotify(idAdmin, id, role, token, urlBack, valor) {
        const headers = new HttpHeaders().set('rol-token', token);
        return this.http.get(`${urlBack}/getNot/${idAdmin}/${id}/${role}?global=${valor}&status=${valor}`, { headers });
    }

    createNotify(idAdmin, id, role, token, urlBack, body) {
        const headers = new HttpHeaders().set('rol-token', token);
        return this.http.post(`${urlBack}/createnot/${idAdmin}/${id}/${role}`, body, { headers });
    }

    updateStatus(idNot, id, role, token, urlBack, body) {
        const headers = new HttpHeaders().set('rol-token', token);
        return this.http.put(`${urlBack}/updateStatusNot/${idNot}/${id}/${role}`, body, { headers });
    }
}
